import { PRODUCTION } from "../../const";
import { clearLoadingStatus } from "../../reducers/loadersSlice";
import { store } from "../store";

export const post = (
  path,
  body,
  setLoadingStatusFor = "",
  onSuccess = () => {},
  onFailed = () => {},
  onComplete = () => {}
) => {
  store.dispatch({
    type: "SET_LOADING_FOR",
    payload: { loadingAction: setLoadingStatusFor },
  });
  fetch(`${process.env.REACT_APP_BASE_URL_V3}${path}`, {
    method: "POST",
    headers: {
      "Content-type": "application/json",
      UserId: "2",
    },
    body: JSON.stringify(body),
  })
    .then((res) => res.json())
    .then((data) => {
      onSuccess(data.data, data);
    })
    .catch((error) => {
      onFailed(error);
    })
    .finally(() => {
      onComplete();
      store.dispatch({
        type: "CLEAR_LOADING_FOR",
        payload: { loadingAction: setLoadingStatusFor },
      }); // removes animation whatever happened
    });
};

export const postAsync = async (
  path,
  body,
  onSuccess = () => {},
  onFailed = () => {},
  onComplete = () => {}
) => {
  await fetch(`${process.env.REACT_APP_BASE_URL}${path}`, {
    method: "POST",
    headers: {
      "Content-type": "application/json",
    },
    body: JSON.stringify(body),
  })
    .then((res) => res.json())
    .then((data) => {
      onSuccess(data.Data, data);
    })
    .catch((error) => {
      console.log(error);
      onFailed(error);
    })
    .finally(() => {
      onComplete();
    });
};

export const postAsyncV2 = async (path, data) => {
  return fetch(`${process.env.REACT_APP_BASE_URL_V3}${path}`, {
    method: "POST",
    headers: {
      "Content-type": "application/json",
      UserId: "2",
    },
    body: JSON.stringify(data),
  });
};

export const getAsyncV2 = async (path) => {
  return fetch(`${process.env.REACT_APP_BASE_URL_V3}${path}`, {
    method: "GET",
    headers: {
      "Content-type": "application/json",
    },
  });
};

export const appoitnmentStatus = (
  body,
  onSuccess = () => {},
  onFailed = () => {},
  onComplete = () => {}
) => {
  fetch(`${process.env.REACT_APP_BASE_URL}`, {
    method: "POST",
    headers: {
      "Content-type": "application/json",
    },
    body: JSON.stringify(body),
  })
    .then((res) => res.json())
    .then((data) => {
      onSuccess(data.Data, data);
    })
    .catch((error) => {
      onFailed(error);
    })
    .finally(() => {
      onComplete();
    });
};

export const viewDoctorStatus = (
  body,
  onSuccess = () => {},
  onFailed = () => {},
  onComplete = () => {}
) => {
  fetch(`${process.env.REACT_APP_BASE_URL_DOCTOR_STATUS}doctor/status/view`, {
    method: "POST",
    headers: {
      "Content-type": "application/json",
    },
    body: JSON.stringify(body),
  })
    .then((res) => res.json())
    .then((response) => {
      onSuccess(response);
    })
    .catch((error) => {
      onFailed(error);
    })
    .finally(() => {
      onComplete();
    });
};

export const getAppointmentPrescription = (
  appointmentId,
  onSuccess = () => {},
  onFailed = () => {},
  onComplete = () => {}
) => {
  fetch(`${process.env.REACT_APP_BASE_URL_DOCTOR_STATUS}prescription/get`, {
    method: "POST",
    headers: {
      "Content-type": "application/json",
    },
    body: JSON.stringify({ appointmentId }),
  })
    .then((res) => res.json())
    .then((response) => {
      onSuccess(response);
    })
    .catch((error) => {
      onFailed(error);
    })
    .finally(() => {
      onComplete();
    });
};

export const get = async (path, onSuccess = () => {}, onFailed = () => {}) => {
  await fetch(`${process.env.REACT_APP_BASE_URL}${path}`, {
    method: "GET",
    headers: {
      "Content-type": "application/json",
    },
  })
    .then((res) => res.json())
    .then((data) => {
      onSuccess(data.Data);
    })
    .catch((error) => {
      onFailed(error);
    });
};


// -------------------------- payment gateway -----------------------------------

export const order = (
  doctorId,
  channelingFee,
  isOtherCountry,
  patientEmail,
  patientMobileNo,
  patientId,
  onSuccess = () => {},
  onFailed = () => {}
) => {
  fetch(`${process.env.REACT_APP_IPG_URL}add/order`, {
    method: "POST",
    headers: {
      "Content-type": "application/json",
    },
    body: JSON.stringify({
      extRefId: doctorId, //doctor id
      amount: channelingFee,
      currency: isOtherCountry ? "USD" : "LKR",
      returnUrl: process.env.REACT_APP_PAYMENT_CALLBACK_URL,
      customerMail: patientEmail,
      customerMobile: patientMobileNo,
      orderSummary: "Video Consultation Fee",
      customerReference: patientId, //patient id
    }),
  })
    .then((res) => res.json())
    .then((data) => {
      onSuccess(data);
    })
    .catch((error) => {
      onFailed(error);
    });
};

export const checkOrder = (
  merchantRID,
  txnId,
  isOtherCountry,
  onSuccess = () => {},
  onFailed = () => {}
) => {
  fetch(`${process.env.REACT_APP_IPG_URL}check/order`, {
    method: "POST",
    headers: {
      "Content-type": "application/json",
    },
    body: JSON.stringify({
      extRefId: "test", //doctor id
      merchantRID: merchantRID,
      currency: isOtherCountry ? "USD" : "LKR",
      txnId: txnId, //id got by transaction
    }),
  })
    .then((res) => res.json())
    .then((data) => {
      onSuccess(data);
    })
    .catch((error) => {
      onFailed(error);
    });
};

// -------------------------- payment gateway -----------------------------------
